import { FormValuesType } from '../../components/investor-management/individual/view/UpdatedDetails';
import { CALL_API } from '../middleware';
import {
  ApplicationNctProps,
  CLEAR_APPLICATION,
  FETCH_INVESTOR_KYC,
  FETCH_INVESTOR_KYC_SUCCESS,
  GET_ALL_NCT_APPLICATION,
  GET_ALL_NCT_APPLICATION_SUCCESS,
  GET_ALL_PENDING_INVESTORS,
  GET_ALL_PENDING_INVESTORS_SUCCESS,
  GET_NCT_APPLICATION,
  GET_NCT_APPLICATION_SUCCESS,
  GetAllChangeRequestBody,
  GetAllNctResponseBody,
  KYC_REPORTS,
  KYC_REPORTS_ARRAY_TYPE,
  KYC_REPORTS_SUCCESS,
  KycReportsResponse,
  NCT_APPROVE,
  NCT_APPROVE_SUCCESS,
  NCT_REJECT,
  NCT_REJECT_SUCCESS,
  PendingInvestorListResponseType,
  UPDATE_NCT_APPLICATION,
  UPDATE_NCT_APPLICATION_SUCCESS,
} from '../types/nct';
import { updatedFromAndToDates } from './reports';

export const approveNct =
  (body: FormValuesType) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amendments/send-for-esigning`,
        method: 'POST',
        types: [NCT_APPROVE_SUCCESS, NCT_APPROVE],
        body,
      },
    });
  };

export const rejectNct =
  (reason: string, body: FormValuesType) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amendments/send-for-esigning`,
        method: 'POST',
        types: [NCT_REJECT_SUCCESS, NCT_REJECT],
        body: { ...body, reason },
      },
    });
  };

export const updateNctApplication =
  ({
    body,
    applicationId,
    toastMessage,
  }: {
    body: Partial<ApplicationNctProps>;
    applicationId: string;
    toastMessage?: string;
  }) =>
  async (dispatch: any): Promise<ApplicationNctProps> => {
    const showToast = typeof toastMessage !== 'undefined';
    if (showToast) {
      toastMessage =
        `Application ${body.applicationNumber || ''} - ` + (toastMessage || ' Saved successfully');
    }
    try {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/investor/${applicationId}/update`,
          method: 'POST',
          types: [UPDATE_NCT_APPLICATION_SUCCESS, UPDATE_NCT_APPLICATION],
          body,
          showToast,
          toastMessage,
        },
      });
    } catch (error: any) {
      console.log('catch error on update application', error);
      throw error;
    }
  };

export const getNctApplicationDetails =
  (applicationId: string, method = '') =>
  async (dispatch: any): Promise<ApplicationNctProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/investor/${applicationId}`,
        method: method ? 'DELETE' : 'GET',
        types: [GET_NCT_APPLICATION_SUCCESS, GET_NCT_APPLICATION],
      },
    });
  };

export const getNctParams = (paramsObj: Partial<GetAllChangeRequestBody>) => ({
  type: 'GET_NCT_PARAMS_DATA',
  paramsObj,
});
export const getAllNctApplications =
  (params: Partial<GetAllChangeRequestBody>) =>
  async (dispatch: any): Promise<GetAllNctResponseBody> => {
    await dispatch(getNctParams(params));
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/investor/investor-change-requests`,
        method: 'GET',
        types: [GET_ALL_NCT_APPLICATION_SUCCESS, GET_ALL_NCT_APPLICATION],
        params: {
          limit: 10,
          sort: 'createdAt',
          order: 'DESC',
          ...params,
        },
      },
    });
  };

export const getAllPendingApplications =
  (params: Partial<GetAllChangeRequestBody>) =>
  async (dispatch: any): Promise<PendingInvestorListResponseType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/investor`,
        method: 'GET',
        types: [GET_ALL_PENDING_INVESTORS_SUCCESS, GET_ALL_PENDING_INVESTORS],
        params: {
          limit: 10,
          sort: 'createdAt',
          order: 'DESC',
          ...params,
        },
      },
    });
  };

export const clearApplication = () => ({
  type: CLEAR_APPLICATION,
});

export const getKycReports =
  (params?: any, reportType?: string) =>
  async (dispatch: any): Promise<KycReportsResponse> => {
    const { from, to } = updatedFromAndToDates(params);
    // 'investor-audit-kyc-report" - CVL KRA  // "investor-audit-report" - Change Requests
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/reports/${
          reportType === 'changeRequests' ? 'investor-audit-report' : 'investor-audit-kyc-report'
        }`,
        method: 'GET',
        types: [KYC_REPORTS_SUCCESS, KYC_REPORTS],
        params: { ...params, from, to, limit: 10 },
        ...(params?.downloadFile && {
          contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      },
    });
  };

export const fetchMismatchInvestors =
  ({
    applicationIds,
    toastMessage,
    params,
  }: {
    applicationIds?: string[];
    toastMessage?: string;
    params?: Partial<GetAllChangeRequestBody>;
  }) =>
  async (dispatch: any): Promise<ApplicationNctProps> => {
    const showToast = typeof toastMessage !== 'undefined';
    try {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/investor/fetch-mismatch-investors`,
          method: 'POST',
          body: { applicationIds },
          types: [FETCH_INVESTOR_KYC_SUCCESS, FETCH_INVESTOR_KYC],
          showToast,
          toastMessage,
          params,
        },
      });
    } catch (error: any) {
      console.log('catch error on fetch kyc', error);
      throw error;
    }
  };
